import styled, { css } from 'styled-components';

import Link from 'Elements/Link';

export const Container = styled.div`
    ${({ theme }) => css`
        margin-top: 0.75rem;

        @media ${theme.breakpoints.medium.media} {
            margin-top: 0;
            margin-right: 3rem;
        }
    `}
`;

export const Label = styled.span`
    ${({ theme }) => css`
        display: inline-block;
        font-size: 1.2rem;

        @media ${theme.breakpoints.medium.media} {
            font-size: 1rem;
            margin-bottom: 0.25rem;
        }

        @media ${theme.breakpoints.large.media} {
            font-size: 1.25rem;
        }
    `}
`;

export const SupportText = styled.div`
    ${({ theme }) => css`
        font-size: 1rem;

        @media ${theme.breakpoints.large.media} {
            font-size: 1.125rem;
            margin-bottom: 0.5rem;
        }
    `}
`;

export const StyledLink = styled(Link)`
    ${({ theme }) => css`
        font-size: 1.125rem;
        display: block;

        @media ${theme.breakpoints.large.media} {
            margin-top: 0;
        }
    `}
`;
